import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Draggable} from 'react-beautiful-dnd';

class BannerChar extends Component {
  render() {
    const {index, model, extraStyle, boxes} = this.props;
    const isMultipleLetters = (model?.letter?.length ?? 1) > 1;
    const charClass = isMultipleLetters ? ' char-group' : '';
    const useDropShadow = model?.dropShadow ?? true;
    const shadowClass = useDropShadow ? 'drop-shadow' : '';
    const fontSize = extraStyle.width * (model.widthScale ?? 1);

    return (
      <Draggable draggableId={model.uuid} index={index}>
        {(provided, snapshot) => (
          <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            className={`designer-banner-char${charClass}`}
            style={getStyle(provided.draggableProps.style, snapshot, boxes, extraStyle.width)}
          >
            {model.letter ? (
              model.letter.split('').map((letter, index) => (
                <p
                  className={shadowClass}
                  key={`${letter}_${index}`}
                  style={{
                    fontFamily: model.fontFamily,
                    fontSize,
                    color: model.colorHex,
                    lineHeight: `${extraStyle.maxHeight}px`,
                    ...extraStyle,
                  }}
                >
                  {letter}
                </p>
              ))
            ) : (
              <p
                className={shadowClass}
                key={`${model.id}_${index}`}
                style={{
                  fontSize,
                  color: model.colorHex,
                  lineHeight: `${extraStyle.maxHeight}px`,
                  ...extraStyle,
                }}
                dangerouslySetInnerHTML={{__html: model.component}}
              ></p>
            )}
          </div>
        )}
      </Draggable>
    );
  }
}

// https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/drop-animation.md
function getStyle(style, snapshot, boxes, width) {
  if (!snapshot.isDropAnimating) return style;

  const {dropAnimation, draggingOver} = snapshot;
  // Only patch style for char-banks
  if (!boxes || !draggingOver?.includes('char-bank')) return style;

  const {moveTo, curve, duration} = dropAnimation;
  const isDroppingBoxEmpty = boxes[draggingOver]?.items.length === 0;
  let x = moveTo.x;
  let y = moveTo.y;

  // console.log(`snapshot: ${JSON.stringify(snapshot)}`);
  // console.log(`moveTo: ${JSON.stringify(moveTo)}`);

  // CharBank1 to occupied CharBank2: drops too far right
  if (draggingOver === 'char-bank-2' && !isDroppingBoxEmpty && y !== 0) {
    // console.log('CharBank1 to occupied CharBank2: drops too far right');
    x = x - width / 2;
  } else if (draggingOver === 'char-bank-2' && isDroppingBoxEmpty) {
    // CharBank1 to empty CharBank2: drops full left
    // console.log('CharBank1 to empty CharBank2: drops full left');
    const containerWidth = document.getElementsByClassName('designer-char-bank')[0].offsetWidth;
    x = x + containerWidth / 2 - width / 2;
  }

  // move to the right spot
  const translate = `translate(${x}px, ${y}px)`;

  // patch the existing style
  return {
    ...style,
    transform: `${translate}`,
    transition: `all ${curve} ${duration}s`,
  };
}

BannerChar.propTypes = {
  index: PropTypes.number.isRequired,
  model: PropTypes.object.isRequired,
};

export default BannerChar;
